var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"digido-form-viewer"},[_c('formio',{attrs:{"form":_vm.schema,"submission":{data: _vm.value},"options":_vm.options},on:{"submit":_vm.submitHandler}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }